import React, { Component } from "react";
import { profile, branch, alert, total, float, toFixed, format_date, random_charactor, GET, POST, PUT, DELETE, loading, Status, params, required, DatePicker, Select, BtnIcon, Swal, Pagination, Switch, Navbar, Modal, Resizer } from "../../../components/CustomComponent.js";
export default class Report extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",

      data: [
        {
          code: "RPT001",
          farmer_name: "สมชาย ใจดี",
          planted_area_rai: 25,
          ratoon_area_rai: 15
        },
        {
          code: "RPT002",
          farmer_name: "สมศรี ศรีสวย",
          planted_area_rai: 30,
          ratoon_area_rai: 10
        },
        {
          code: "RPT003",
          farmer_name: "ประหยัด ดวงดี",
          planted_area_rai: 18,
          ratoon_area_rai: 22
        },
        {
          code: "RPT004",
          farmer_name: "สุดใจ จันทร์เพ็ญ",
          planted_area_rai: 40,
          ratoon_area_rai: 12
        },
        {
          code: "RPT005",
          farmer_name: "มนัส ชาญชัย",
          planted_area_rai: 35,
          ratoon_area_rai: 20
        },
        {
          code: "RPT006",
          farmer_name: "สายใจ บัวบาน",
          planted_area_rai: 28,
          ratoon_area_rai: 14
        },
        {
          code: "RPT007",
          farmer_name: "ทองดี ทองแท้",
          planted_area_rai: 22,
          ratoon_area_rai: 18
        },
        {
          code: "RPT008",
          farmer_name: "กัญญา เพชรรุ่ง",
          planted_area_rai: 31,
          ratoon_area_rai: 16
        },
        {
          code: "RPT009",
          farmer_name: "ประวิทย์ รักไทย",
          planted_area_rai: 27,
          ratoon_area_rai: 13
        },
        {
          code: "RPT010",
          farmer_name: "วรรณา ใจงาม",
          planted_area_rai: 33,
          ratoon_area_rai: 19
        }
      ],
      count: 0,
    };
  }

  async componentDidMount() {
    loading(false);
    await this.Get(1);
  }
  Get = async (page) => {
    loading(true);
    let result = await GET("admin/manage/customers/list", { page: page, data_search: this.state.search });
    if (result?.status) {
      this.setState({ data: result.data, count: result.count });
    }
    loading(false);
  };
  render() {
    const { search, data, count } = this.state;
    return (
      <div className="w-100 min-vh-100 bg-light">
        <Navbar />
        <div className="body p-3">
          <div className="rounded-4 bg-white p-3">
            <div className="d-flex flex-wrap">
              <h4 className="fw-bold mb-3 me-3">รายงานพื้นที่อ้อย</h4>
              <input
                type="text"
                className="form-control wpx-250 me-2 mb-2"
                placeholder="ค้นหา..."
                onChange={(e) => {
                  this.setState({ search: e.target.value });
                }}
                onKeyUp={(e) => {
                  if (e.key === "Enter") {
                    this.Get(1);
                  }
                }}
                value={search}
              />
              <div className="d-flex">
                <button
                  className="btn btn-primary px-3 me-2 mb-2"
                  onClick={() => {
                    this.Get(1);
                  }}
                >
                  ค้นหา
                </button>
                <button
                  className="btn btn-outline-primary px-3 me-2 mb-2"
                  onClick={() => {
                    window.location.reload();
                  }}
                >
                  ล้างค่า
                </button>
              </div>
              <button
                className="btn btn-primary px-3 ms-auto mb-2"
                onClick={async () => {}}
              >
                Export Excel
              </button>
            </div>
            <div className="table-responsive">
              <table className="table rounded-3 overflow-hidden table-hover">
                <thead>
                  <tr>
                    <td className="wpx-150">รหัส</td>
                    <td>ชาวไร่</td>
                    <td>อ้อยปลูก (ไร่)</td>
                    <td>อ้อยตอ (ไร่)</td>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item, index) => (
                    <tr>
                      <td>{item.code || "-"}</td>
                      <td>{item.farmer_name || "-"}</td>
                      <td>{item.planted_area_rai || "-"}</td>
                      <td>{item.ratoon_area_rai || "-"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="w-100 d-flex align-items-center justify-content-between flex-wrap mt-2">
            <span className="mb-3">รายการทั้งหมด {count || 0} รายการ</span>
            <Pagination className="mb-3" count={Math.ceil(count / 10) || 1} showFirstButton showLastButton onChange={(_, page) => this.Get(page)} />
          </div>
        </div>
      </div>
    );
  }
}
